<template>
  <v-col
    @contextmenu.stop="handleContextMenuColumn($event)"
    @mouseup.stop="handleMouseUp"
    :cols="colonna.dimensione"
    :style="{
      backgroundColor:
        colonna.selezionata === 0 ? colonna.colore_colonna : '#808080',
      border: '1px solid black',
      borderStyle: 'dashed',
      padding: '5px',
    }"
  >
    <div
      style="background-color: white"
      v-if="colonna.oggetto.filter((o) => o.validita == 1).length > 0"
    >
      <!-- Renderizzazione dei bottoni -->
      <span
        v-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'B'
        "
      >
        <div
          @contextmenu.stop="handleContextMenuObject($event)"
          :style="{
            background:
              o.colore_sfondo == 'success'
                ? '#4caf50'
                : o.colore_sfondo == 'error'
                ? '#ff5252'
                : o.colore_sfondo == 'grey lighten-5'
                ? '#FAFAFA'
                : o.colore_sfondo == 'primary'
                ? '#1976d2'
                : o.colore_sfondo,
            display: 'inline-block',
          }"
          v-for="(o, i) in colonna.oggetto.filter(
            (o) => o.tipo_oggetto == 'B' && o.validita == 1
          )"
          :key="i"
        >
          <v-icon :color="o.colore_icona">
            {{ o.icona }}
          </v-icon>
        </div>
      </span>

      <!-- Renderizzazione dei dati -->
      <div
        @contextmenu.stop="handleContextMenuObject($event)"
        :style="{
          background: colonna.colore_sfondo,
        }"
        v-else-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'D'
        "
      >
        <span
          :style="{
            color: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_color_titolo,
            fontSize:
              colonna.oggetto.filter((o) => o.validita == 1)[0]
                .font_size_titolo -
              2 +
              'px',
            fontWeight: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_weight_titolo,
          }"
        >
          {{ colonna.oggetto.filter((o) => o.validita == 1)[0].tooltip }} </span
        ><br />
        <span
          :style="{
            color: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_color_dato,
            fontSize:
              colonna.oggetto.filter((o) => o.validita == 1)[0].font_size_dato -
              2 +
              'px',
            fontWeight: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_weight_dato,
          }"
          >[Dato]
        </span>
      </div>

      <!-- Renderizzazione delle notifiche -->
      <div
        @contextmenu.stop="handleContextMenuObject($event)"
        :style="{
          backgroundColor: colonna.oggetto.filter((o) => o.validita == 1)[0]
            .colore_sfondo,
        }"
        v-else-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'N'
        "
      >
        <span
          :style="{
            color: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_color_dato,
            fontSize:
              colonna.oggetto.filter((o) => o.validita == 1)[0].font_size_dato -
              2 +
              'px',
            fontWeight: colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_weight_dato,
          }"
        >
          {{ colonna.oggetto.filter((o) => o.validita == 1)[0].tooltip }}
        </span>
      </div>

      <!-- Renderizzazione delle immagini -->
      <div
        @contextmenu.stop="handleContextMenuObject($event)"
        :style="{
          background: colonna.colore_sfondo,
        }"
        v-else-if="
          colonna.oggetto.filter((o) => o.validita == 1)[0].tipo_oggetto === 'I'
        "
      >
        [{{ colonna.oggetto.filter((o) => o.validita == 1)[0].testo }}]
      </div>
    </div>
    <v-container fluid v-else>
      <LayoutRow
        :drag_state="drag_state"
        :is_intestazione="is_intestazione"
        :key="i"
        :riga="riga"
        v-for="(riga, i) in colonna.righe.filter((r) => r.validita == 1)"
      ></LayoutRow>
    </v-container>
  </v-col>
</template>
<script>
export default {
  name: "LayoutColumn",
  components: { LayoutRow: () => import("@/components/LAYOUT/LayoutRow.vue") },
  props: {
    colonna: { type: Object, default: () => {} },
    drag_state: { type: String, default: "off" },
    is_intestazione: { type: Number, default: 0 },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    handleMouseUp() {
      if (this.drag_state == "on") {
        this.handleDragEnd();
      } else {
        this.handleClick();
      }
    },
    handleClick() {
      // Costruisco un messaggio.
      const messaggio = {
        detail: {
          id_layout_struttura_tmp: this.colonna.id_layout_struttura_tmp,
        },
        src: null,
      };

      // Metto il messaggio nell'evento.
      const evento = new CustomEvent("clickedColumn", messaggio);

      // Consegno l'evento alla mia destinazione.
      document.getElementById("listener_layout").dispatchEvent(evento);
    },
    handleContextMenuColumn(e) {
      // Ho cliccato col destro, ma prevengo il menu contestuale del browser. */
      e.preventDefault();

      // Costruisco un messaggio.
      const messaggio = {
        detail: {
          id_layout_struttura_tmp: this.colonna.id_layout_struttura_tmp,
        },
        src: null,
      };

      // Metto il messaggio nell'evento.
      const evento = new CustomEvent("contextMenuColumn", messaggio);

      // Consegno l'evento alla mia destinazione.
      document.getElementById("listener_layout").dispatchEvent(evento);
    },
    handleContextMenuObject(e) {
      // Ho cliccato col destro, ma prevengo il menu contestuale del browser. */
      e.preventDefault();

      // Costruisco un messaggio.
      const messaggio = {
        detail: {
          id_layout_struttura_tmp: this.colonna.id_layout_struttura_tmp,
        },
        src: null,
      };

      // Metto il messaggio nell'evento.
      const evento = new CustomEvent("contextMenuObject", messaggio);

      // Consegno l'evento alla mia destinazione.
      document.getElementById("listener_layout").dispatchEvent(evento);
    },
    handleDragEnd() {
      // Costruisco un messaggio.
      const messaggio = {
        detail: {
          id_layout_struttura_tmp: this.colonna.id_layout_struttura_tmp,
          caveat: this.is_intestazione == 1 ? "intestazione" : null,
        },
        src: null,
      };

      // Metto il messaggio nell'evento.
      const evento = new CustomEvent("endOfDrag", messaggio);

      // Consegno l'evento alla mia destinazione.
      document.getElementById("listener_layout").dispatchEvent(evento);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>